
import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { MatRippleModule } from '@angular/material/core'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule, MatIconRegistry } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { ToolbarService } from './fc-toolbar.service'
import { BlatOutServiceApi } from '../../core/api/blatout/blatout.api'
import { AuthenticatedUser } from '../../core/interfaces/user.interface'
import { PipesModule } from '../../core/pipes/pipes.module'
import { BlatOutService } from '../../core/services/blatout/blatout.service'
import { TranslationLoaderService } from '../../core/services/i18n/i18n.service'
import { ToolbarNotificationService } from '../../core/services/notifications/notifications.service'

@Component({
    selector: 'fc-toolbar',
    templateUrl: './fc-toolbar.component.html',
    styleUrls: ['./fc-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [
    BrowserModule,
    MatBadgeModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatRippleModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    PipesModule
],
    providers: [
        BlatOutService,
        BlatOutServiceApi,
        ToolbarService,
        ToolbarNotificationService,
    ]
})
export class NgxFieldControlToolbarComponent implements OnInit {
  @Input() public user!: AuthenticatedUser | null
  @Input() public environment!: any
  @Input() public unreadNotificationsCount!: string

  public constructor(
    private readonly translationLoaderService: TranslationLoaderService,
    private readonly domSanitizer: DomSanitizer,
    private readonly blatOutService: BlatOutService,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly ngxFieldControlToolbarService: ToolbarService,
  ) {
    this.translationLoaderService.initialize()

    this.matIconRegistry.addSvgIcon('pendency', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/pendency.svg'))
    this.matIconRegistry.addSvgIcon('storage', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/storage.svg'))
    this.matIconRegistry.addSvgIcon('storage-filled', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/storage-filled.svg'))
    this.matIconRegistry.addSvgIcon('pendency-filled', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/pendency-filled.svg'))
  }

  public async ngOnInit(): Promise<void> {
    await this.blatOutService.load(this.user)
  }

  public async openBlatOut(): Promise<void> {
    await this.blatOutService.load(this.user)
    this.blatOutService.open()
  }

  @HostListener('window:open-notifications-dialog')
  public async openNotificationsDialog(): Promise<void> {
    await this.ngxFieldControlToolbarService.openNotificationsDialog(this.environment)
  }

  public async openVideoDialog(): Promise<void> {
    await this.ngxFieldControlToolbarService.openVideoDialog('https://www.youtube.com/embed/xIkeK6lHJYc')
  }

  public openLink(link: string): void {
    window.open(link, '_blank')
  }

  public logout(): void {
    localStorage.removeItem('REFRESH_TOKEN')
    localStorage.removeItem('ACCESS_TOKEN')
    window.location.href = this.environment.MOUNTDOOM_URL
  }

  public profile(): void {
    window.location.href = `${this.environment.MOUNTDOOM_URL}/#/perfil`
  }

  public trackByFn(index: number): number {
    return index
  }
}
